var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStripe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1959_3537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.39 0H6.48C2.90119 0 0 2.90119 0 6.48V22.39C0 25.9688 2.90119 28.87 6.48 28.87H22.39C25.9688 28.87 28.87 25.9688 28.87 22.39V6.48C28.87 2.90119 25.9688 0 22.39 0Z",
    fill: "#6772E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3 11.2001C13.3 10.5101 13.87 10.2001 14.79 10.2001C16.3145 10.2331 17.8106 10.6199 19.16 11.3301V7.24013C17.7716 6.69567 16.2912 6.42405 14.8 6.44013C11.24 6.44013 8.85999 8.30013 8.85999 11.4401C8.85999 16.3001 15.54 15.5101 15.54 17.6101C15.54 18.4201 14.83 18.6801 13.86 18.6801C12.1512 18.5859 10.4875 18.0964 8.99999 17.2501V21.4401C10.5157 22.0951 12.1488 22.4353 13.8 22.4401C17.45 22.4401 19.97 20.6401 19.97 17.4401C20 12.2301 13.3 13.1701 13.3 11.2001V11.2001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1959_3537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.87,
    height: 28.87,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/Stripe.0c544776e513635cfb84236ae098f3b7.svg";
export { ForwardRef as ReactComponent };